// Identity template tag for GraphQL strings. Returns the concatenated source.
// Authors write `export const query = gql`...`` so editors can recognize and
// syntax-highlight GraphQL inside the template literal. Rails parses the
// component_code at admin save and extracts the literal string.
export const gql = (strings: TemplateStringsArray, ...values: unknown[]): string => {
  return strings.reduce((acc, str, i) => {
    return acc + str + (i < values.length ? String(values[i]) : '');
  }, '');
};
